function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M401.819,206.077c-8.33-8.331-21.838-8.331-30.17,0l-85.48,85.481l-45.254-45.257c-4.001-4.001-9.426-6.249-15.086-6.249 c-5.658,0-11.083,2.247-15.084,6.249L110.18,346.869c-8.331,8.33-8.331,21.838,0,30.17c4.166,4.166,9.626,6.248,15.084,6.248 c5.46,0,10.92-2.084,15.084-6.248l85.481-85.478l45.254,45.254c4.001,4.001,9.427,6.248,15.086,6.248 c5.658,0,11.083-2.247,15.084-6.248l100.567-100.567C410.15,227.917,410.15,214.409,401.819,206.077z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M469.333,42.667H334.222V21.333C334.222,9.552,324.671,0,312.889,0H199.111c-11.782,0-21.333,9.552-21.333,21.333v21.333 H42.667c-11.782,0-21.333,9.552-21.333,21.333v426.667c0,11.782,9.552,21.333,21.333,21.333h426.667 c11.782,0,21.333-9.552,21.333-21.333V64C490.667,52.218,481.115,42.667,469.333,42.667z M220.444,42.667h71.111v21.249 c0,0.028-0.004,0.055-0.004,0.084s0.004,0.055,0.004,0.084v21.249h-71.111V42.667z M448,469.333H64v-384h113.778v21.333 c0,11.782,9.552,21.333,21.333,21.333h113.778c11.782,0,21.333-9.552,21.333-21.333V85.333H448V469.333z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var SvgStatsIcon = function SvgStatsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/StatsIcon.22af94b1.svg";
export { ForwardRef as ReactComponent };